import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  DEFAULT_PAYMENT_KIND,
  IPaymentKindPickerProps,
  PaymentKindPicker,
} from '@work4all/components/lib/components/entity-picker/PaymentKindPicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<IPaymentKindPickerProps<false>, 'multiple' | 'clearable'> {
  error?: string;
}

export const PaymentKindPickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const { error, ...pickerProps } = props;
    const { value } = pickerProps;

    return (
      <EntityPickerPopover
        picker={
          <PaymentKindPicker
            {...pickerProps}
            clearable={false}
            multiple={false}
          />
        }
      >
        <PickerTargetButton
          ref={ref}
          label={t('INPUTS.PAYMENT_KIND')}
          error={error}
          value={value?.note || t(DEFAULT_PAYMENT_KIND.translationKey)}
        />
      </EntityPickerPopover>
    );
  }
);
